<ng-container [formGroup]="formGroup">
  <div class="p500-ui-modal__group" *ngFor="let config of groups">
    <div *ngIf="config.name" class="head">
      <div
        class="p500-ui-modal__body-title"
        [class.-accordion]="config.isCollapsed"
        (click)="config.initialCollapsedState = !config.initialCollapsedState"
      >
        <span class="title" [ngClass]="config.nameClass">{{ config.name }}</span>
        <p500-ui-icon
          *ngIf="config.isCollapsed"
          class="icon"
          [name]="config.initialCollapsedState ? 'arrows-select-up' : 'arrows-select-down'"
        >
        </p500-ui-icon>
      </div>
    </div>
    <div [hidden]="config.initialCollapsedState === false" class="row">
      <ng-container *ngFor="let field of config.fields; index as idx">
        <div
          *ngIf="components.get(field)"
          class="c-form__section col-12"
          gtdFieldWidth
          [grid]="config.col"
          [fields]="config.fields.length"
          [fieldIDx]="idx"
          [hidden]="dependHideFields[field] && (dependHideFields[field] | async)"
        >
          <p500-ui-control-dynamic-component
            [component]="components.get(field)"
            [settings]="componentsSettings.get(field)"
            #dynamic
          ></p500-ui-control-dynamic-component>
          <ng-container *ngIf="actionConfig.getHint(field) as hint">
            <gtd-hints [hint]="hint"></gtd-hints>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
